import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import LikeButton from "@/components/LikeButton";

/**
 * Compact card used in the Browse "Featured" strip (Top Dog / Just Listed /
 * Fan Favorites). Deliberately smaller than the full ListingCard so the
 * showcase feels like a tidy header rather than another grid section.
 *
 *   [image]
 *   TITLE (truncated to one line)
 *   $price          👍 count
 */
export default function MiniListingCard({ listing, liked = false }) {
  const img = imgUrl(listing.front_image, { w: 320 });
  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`mini-card-${listing.id}`}
      className="group h57-surface h57-surface-hover flex flex-col transition-transform duration-150 hover:-translate-y-0.5"
    >
      <div className="aspect-[3/4] bg-[#0A0A0A] relative overflow-hidden">
        {img ? (
          <img src={img} alt={listing.title} className="w-full h-full object-contain" loading="lazy" decoding="async" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-mono text-[9px] text-zinc-700 tracking-widest">NO IMG</div>
        )}
      </div>
      <div className="p-1.5 flex flex-col gap-0.5">
        <div className="font-display font-bold text-[10px] leading-tight line-clamp-1 uppercase tracking-tight" title={listing.title}>
          {listing.title}
        </div>
        <div className="flex items-center justify-between gap-1.5">
          <div className="font-display font-black text-xs text-[#FF5F1F] tabular-nums">
            ${Number(listing.price).toFixed(0)}
          </div>
          <LikeButton
            listingId={listing.id}
            initialLiked={liked}
            initialCount={listing.likes_count || 0}
          />
        </div>
      </div>
    </Link>
  );
}
